/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Model_Id_PlaceholderInputs */



/**
* | output |
* | --- |
* | "private-llama3-70b" |
*
* @param {Private_Models_Form_Model_Id_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_model_id_placeholder = /** @type {((inputs?: Private_Models_Form_Model_Id_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Model_Id_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("private-llama3-70b")
	return /** @type {LocalizedString} */ ("private-llama3-70b")
});